export default __webpack_public_path__ + "static/media/two-factor-authentication-illustration.98d06477.svg";